import config from '../config/environment';
import supabase from '../config/supabase';
import { AnamnesisService } from './AnamnesisService';

const AI_EVENT_TYPE_ANAMNESE = 0;
const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 90_000;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

async function readAiSummary(studentId: number): Promise<string> {
  const latest = await AnamnesisService.findByStudentId(studentId);
  return typeof latest?.ai_summary === 'string' ? latest.ai_summary.trim() : '';
}

class AnamnesisAiSummaryServiceClass {
  async generate(studentId: number): Promise<string> {
    if (!Number.isInteger(studentId) || studentId <= 0) {
      throw new Error('Aluna inválida para gerar o resumo da anamnese.');
    }

    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token;

    if (!token) {
      throw new Error('Usuária não autenticada. Faça login novamente.');
    }

    const previousSummary = await readAiSummary(studentId);

    let response: Response;
    try {
      response = await fetch(`${config.supabaseFunctionsUrl}/IAServices`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          apikey: config.supabaseAnonKey,
        },
        body: JSON.stringify({
          AIEventType: AI_EVENT_TYPE_ANAMNESE,
          Input: `Faça o resumo da anamnese da aluna ${studentId}`,
          Title: `Resumo aluna ${studentId}`,
        }),
      });
    } catch {
      throw new Error(
        'Não foi possível chamar o serviço de IA (rede/CORS). Confira o IAServices.',
      );
    }

    // Contrato: 202 Accepted (também aceita 201). Body vazio — resumo vem de anamnesis.ai_summary.
    if (response.status !== 202 && response.status !== 201) {
      throw new Error('Não foi possível gerar o resumo da anamnese.');
    }

    const deadline = Date.now() + POLL_TIMEOUT_MS;
    while (Date.now() < deadline) {
      const current = await readAiSummary(studentId);
      if (current && current !== previousSummary) {
        return current;
      }
      await sleep(POLL_INTERVAL_MS);
    }

    throw new Error(
      'O resumo ainda não ficou pronto. Tente novamente em instantes.',
    );
  }
}

export const AnamnesisAiSummaryService = new AnamnesisAiSummaryServiceClass();
